'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var React = require('react');
var Button = require('@narvar/nth-block-button');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Button__default = /*#__PURE__*/_interopDefaultLegacy(Button);

const FileUploadButton = _ref => {
  let {
    accept,
    multiple,
    maxSize,
    onChange,
    children,
    ...props
  } = _ref;
  const fileInput = React.useRef(null);
  const handleChange = event => {
    const files = event.target.files;
    const acceptedFiles = [];
    const rejectedFiles = [];
    if (files) {
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        if (maxSize && maxSize > 0 && file.size > maxSize) {
          rejectedFiles.push(file);
          continue;
        }
        acceptedFiles.push(file);
      }
    }
    onChange === null || onChange === void 0 ? void 0 : onChange(acceptedFiles, rejectedFiles, event);
  };
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(Button__default["default"], _extends__default["default"]({
    onClick: () => {
      var _fileInput$current;
      return (_fileInput$current = fileInput.current) === null || _fileInput$current === void 0 ? void 0 : _fileInput$current.click();
    }
  }, props), children), /*#__PURE__*/React__default["default"].createElement("input", {
    ref: fileInput,
    "data-testid": "file-upload-button__file-input",
    type: "file",
    accept: accept,
    multiple: multiple,
    onChange: handleChange,
    style: {
      display: 'none'
    }
  }));
};

exports["default"] = FileUploadButton;
